import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Avatar,
  Box,
  Button,
  Dropdown,
  DropdownBody,
  DropdownItem,
  getColor,
  Icons,
  InfiniteScrollBox,
  Tabs,
  Tooltip,
  Typography,
  useToast,
} from "fds";
import "../index.scss";
import dayjs from "dayjs";
import utilsCommon from "../../../shared/utils/common";
import { DocInfo, DocumentListReq, favoriteReq } from "../../../types/files";
import useWorkgroupStore from "../../../redux/dispatcher/useWorkgroupStore";
import { meetingDTO } from "../../../types/meeting";
import MeetingBottom from "../../../components/MeetingBottom";
import DateDropdown from "../../../components/DateDropdown";
import classNames from "classnames";
import RevisionTag from "../../../components/RevisionTag";
import utilsDocs from "../../../shared/utils/docs";
import { Workgroup } from "../../../types/workgroup";
import useDocumentStore from "../../../redux/dispatcher/useDocumentStore";
import EmptyInitFilterPage from "../../../components/EmptyPage/EmptyInitFilterPage";
import EmptyFilterPage from "../../../components/EmptyPage/EmptyFilterPage";
import {
  doUnauthDocDownload,
  handleDocDownload,
  handleDocPreview,
} from "../../../shared/utils/api";
import useStartDownload from "../../../shared/hooks/useStartDownload";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
const sort_by = [
  { resource: t("common.sortDateNewFirst"), key: "datedesc" },
  { resource: t("common.sortDateNewLast"), key: "date" },
  { resource: t("common.sortDateNameAsc"), key: "name" },
  { resource: t("common.sortDateNameDesc"), key: "namedesc" },
];
const TAB_VALUES = [
  { key: "file", resource: t("common.file"), index: 0 },
  {
    key: "meeting",
    resource: t("common.meetings"),
    index: 1,
    isHidden: utilsCommon.checkMenuAvailable("zoom") === false,
  },
];
const ClientBookmark = () => {
  const direction = document.documentElement.dir; // 'ltr' 또는 'rtl'

  const INIT_MEETING_FILTER = {
    contentPos: 0,
    date: {
      start: utilsCommon.getStartPeriod("1month"),
      end: dayjs().valueOf(),
    },
    meetingPos: 0,
    order: "datedesc",
    page: { meeting: 0, content: 0 },
    resultSize: 30,
    ver: "1.0",
    workgroupIds: [],
  } as favoriteReq;
  const INIT_CONTENT_FILTER = {
    date: {
      start: utilsCommon.getStartPeriod("1month"),
      end: dayjs().valueOf(),
    },
    folderCode: "",
    masterUserId: "",
    order: "datedesc",
    page: 0,
    readType: "favorit",
    search: "",
    size: 50,
    tagCodes: [],
  };
  const [settingButtonInfo, setDocSettingInfo] = useState<{
    x: number;
    y: number;
    syncId: string;
    docInfo?: DocInfo;
  }>({
    x: 0,
    y: 0,
    syncId: "",
    docInfo: undefined,
  });
  const documentListNewCard = useRef([] as any[]);
  const {
    documentState,
    getContentList,
    getContentFavorite,
    getContentDownload,
    getDocDecryptDownload,
  } = useDocumentStore();
  const startDownload = useStartDownload();
  const { workgroupState, getFavoriteMeetingList } = useWorkgroupStore();
  const [buttonClick, setButtonClick] = useState(0);
  const [meetingList, changeMeetingList] = useState<meetingDTO[]>([]);
  const [docList, changeDocList] = useState<DocInfo[]>();
  const [dateFilter, changeDateFilter] = useState<string>("1month");
  const [tab, changeTab] = useState(0);
  const [docFilter, changeDocFilters] =
    useState<DocumentListReq>(INIT_CONTENT_FILTER);
  const [meetingFilter, changeMeetingFilters] =
    useState<favoriteReq>(INIT_MEETING_FILTER);
  const [key, setKey] = useState(0);
  const inputRef = useRef<HTMLTableRowElement>(null);
  const { t } = useTranslation();

  const toasts = useToast();
  const handleClickOutside = useCallback((e?: MouseEvent) => {
    if (inputRef.current && !(inputRef.current! as any).contains(e?.target)) {
      handleTurnOffSettng();
      document.removeEventListener("click", handleClickOutside, true);
    }
  }, []);
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    document.addEventListener("scroll", handleTurnOffSettng, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
      document.removeEventListener("scroll", handleTurnOffSettng, true);
    };
  });
  useEffect(() => {
    if (workgroupState.simpleWorkgroupList)
      changeDocFilters({
        ...docFilter,
        tagCodes: workgroupState.simpleWorkgroupList.map(
          (item: Workgroup) => item.workgroupId
        ),
      });
  }, [workgroupState.simpleWorkgroupList]);
  useEffect(() => {
    let newDataCardContent = [] as any[];
    docList?.forEach((item: DocInfo, index: number) =>
      newDataCardContent.push(getTableCardData(item, index))
    );
    documentListNewCard.current = newDataCardContent;
    setKey(key + 1);
  }, [docList]);

  useEffect(() => {
    changeDocList(documentState.docList);
  }, [documentState.docList]);
  useEffect(() => {
    changeMeetingList(workgroupState.favoriteMeetingList);
  }, [workgroupState.favoriteMeetingList]);
  useEffect(() => {
    getContentList(docFilter);
  }, [docFilter]);
  useEffect(() => {
    if (utilsCommon.checkMenuAvailable("zoom") && meetingFilter)
      getFavoriteMeetingList(meetingFilter);
  }, [meetingFilter]);
  const handleTurnOffSettng = (): void => {
    setDocSettingInfo({
      x: 0,
      y: 0,
      syncId: "",
      docInfo: undefined,
    });
  };
  /** 문서 상세정보 모달 열기 기능 */
  const handleOpenClientDocInfo = (syncId: string) => {
    if (utilsCommon.isClientLogin("MAC")) {
      (window as any)?.webkit?.messageHandlers.DocDetail.postMessage(syncId);
    } else if (utilsCommon.isClientLogin("WINDOWS")) {
      window?.chrome?.webview?.hostObjects.client.DocDetail(syncId);
    }
    handleTurnOffSettng();
  };
  /** 문서 다운로드 기능 */
  const handleDocClientDownload = async (syncId: string) => {
    handleDocDownload(
      syncId,
      getContentDownload,
      toasts,
      t,
      "0",
      docList?.filter((item) => item.syncId === syncId)[0]?.contentName ?? ""
    );
    handleTurnOffSettng();
  };
  const getTableCardData = (row: DocInfo, index: any) => {
    return {
      id: row?.syncId,
      data: (
        <Box
          classes="clientFile-item"
          style={{ border: "1px solid #E9ECEF", marginTop: "12px" }}
        >
          <Box classes="clientEco-groups">
            <Avatar
              name={
                row.workgroup.workgroupId === "NONEWORKGROUP"
                  ? "My Box"
                  : row.workgroup.workgroupName
              }
              uniqueCode={row.workgroup.workgroupId}
              shape="workgroup"
            />
            {utilsDocs.renderDocIcon(row?.contentName, 32)}
          </Box>
          <Box direction="column" width={"calc(100% - 85px)"} classes="mg ml-8">
            <Box alignItems="center">
              <Tooltip
                message={row?.contentName}
                maxWidth={"calc(100% - 25px)"}
              >
                <Typography
                  type="body2_rg"
                  ellipsis
                  onClick={() =>
                    handleDocPreview({
                      permission: "view",
                      workgroupId: row.workgroup.workgroupId,
                      syncId: row.syncId,
                      toast: toasts,
                      t,
                      revisionNo: 0,
                    })
                  }
                  classes={classNames({
                    "hover-text-underline": utilsCommon.checkMenuAvailble(
                      "preview",
                      row
                    ),
                  })}
                >
                  {row?.contentName}
                </Typography>
              </Tooltip>
              {row?.revisionNo > 1 && (
                <RevisionTag
                  classes={"mg ml-4"}
                  size={"sm"}
                  revisionNo={row?.revisionNo}
                />
              )}
            </Box>
            <Box classes="mg mt-6">
              <Tooltip
                message={row?.masterUser?.userName}
                maxWidth={"calc(100% - 125px)"}
              >
                <Typography
                  type="caption1_rg"
                  ellipsis
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {row?.masterUser?.userName}
                </Typography>
              </Tooltip>
              <Typography
                type="caption1_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
                classes="mg ml-4"
              >
                {` · ${utilsCommon.renderDateFormat(row?.revisionDate)}`}
              </Typography>
            </Box>
          </Box>
          {row?.authType !== "N" &&
            !!row?.favoritDate &&
            row?.favoritDate > 0 && (
              <Box classes="cursor pointer mg ml-auto">
                <Icons variant="fill" label="star" isColored size={20} />
              </Box>
            )}
          {row?.authType !== "N" && (
            <Box classes="hover-actions">
              <Tooltip
                message={
                  row?.favoritDate > 0
                    ? t("file.action.removeFav")
                    : t("file.action.addFav")
                }
              >
                <Button
                  btnStyle="icon"
                  onClick={() =>
                    getContentFavorite({
                      syncIds: [row?.syncId],
                      flag: row?.favoritDate <= 0,
                      page: "favorite",
                    })
                  }
                  leadingIcon={
                    <Icons
                      variant="fill"
                      label="star"
                      isColored={!!row?.favoritDate && row?.favoritDate > 0}
                      size={20}
                    />
                  }
                />
              </Tooltip>
              <Button
                btnStyle={"icon"}
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  setDocSettingInfo({
                    x: direction ? e.pageX : e.pageX - 120,
                    y:
                      350 > e.pageY
                        ? e.pageY
                        : e.pageY -
                          (utilsCommon.checkMenuAvailble(
                            "unAuthDownload",
                            settingButtonInfo.docInfo,
                            "client"
                          )
                            ? 52
                            : 98),
                    syncId: row?.syncId,
                    docInfo: row,
                  });
                }}
                leadingIcon={<Icons variant="line" label="moreVertical" />}
              />
            </Box>
          )}
        </Box>
      ),
    };
  };
  const changeFilterByKey = (key: string, value: any) => {
    let newValue = value;
    if (key === "order") {
      if (value.includes("_direct")) {
        newValue = value.split("_direct")[0];
      } else {
        if (value === "name") {
          if (meetingFilter.order.includes("date")) {
            newValue = "namedesc";
          } else {
            newValue = meetingFilter.order === "namedesc" ? "name" : "namedesc";
          }
        } else {
          if (meetingFilter.order.includes("name")) {
            newValue = "datedesc";
          } else {
            newValue = meetingFilter.order === "datedesc" ? "date" : "datedesc";
          }
        }
      }
    } else if (key === "date") {
      if (typeof value !== "object") {
        changeDateFilter(value);
        changeMeetingFilters({
          ...meetingFilter,
          date: {
            start: utilsCommon.getStartPeriod(value),
            end: dayjs().valueOf(),
          },
        });
        changeDocFilters({
          ...docFilter,
          date: {
            start: utilsCommon.getStartPeriod(value),
            end: dayjs().valueOf(),
          },
        });
      } else {
        changeDateFilter("custom");
        changeDocFilters({
          ...docFilter,
          date: {
            start: dayjs(value.start).valueOf(),
            end: dayjs(value.end).valueOf(),
          },
        });
        changeMeetingFilters({
          ...meetingFilter,
          date: {
            start: dayjs(value.start).valueOf(),
            end: dayjs(value.end).valueOf(),
          },
        });
      }
      return;
    }
    changeMeetingFilters({ ...meetingFilter, [key]: newValue });
    changeDocFilters({
      ...docFilter,
      [key]: newValue.replace("name", "file"),
    });
  };
  const renderFileFilter = () => {
    return (
      <Box classes="clientFile-filter">
        <DateDropdown
          filter={meetingFilter}
          buttonClick={buttonClick}
          showValue={false}
          positionStrategy="fixed"
          setButtonClick={setButtonClick}
          dateFilter={dateFilter}
          changeFilterByKey={changeFilterByKey}
          isClient
          initValue="1month"
        />
      </Box>
    );
  };
  return (
    <Box
      classes="clientBookmark clientWorkgroupBody"
      width={"calc(100% - 64px)"}
    >
      <Box height={88} alignItems="center" classes="clientBookmark-header ">
        <Typography type="h2">{t("bookmark.title")}</Typography>
      </Box>
      <Tabs
        type={"leftFull"}
        selected={tab}
        textAlign={"left"}
        selectTab={(newTab) => changeTab(newTab)}
        tabs={TAB_VALUES.map((item) => {
          return {
            text: item.resource,
            color: "default",
            isNew: false,
            isHidden: item.isHidden,
          };
        })}
        paddingLeft={20}
        size={"md"}
      />
      <Box classes="clientWorkgroupBody-header">
        <Dropdown
          btnStyle="link"
          placeholder="asdf"
          buttonClick={buttonClick}
          value={
            sort_by.filter((item) => item.key === meetingFilter.order)[0]
              .resource
          }
        >
          {sort_by.map((item) => (
            <DropdownItem
              label={item.resource}
              type="check"
              checked={item.key === meetingFilter.order}
              checkColor={item.key === meetingFilter.order}
              onClick={() => {
                changeFilterByKey("order", item.key + "_direct");
                setButtonClick(buttonClick + 1);
              }}
            />
          ))}
        </Dropdown>
      </Box>
      {renderFileFilter()}
      {tab === 0 ? (
        documentState.docListInfo?.docs?.doc?.length === 0 ? (
          dateFilter === "1month" ? (
            <EmptyInitFilterPage pageType={"client"} />
          ) : (
            <EmptyFilterPage pageType={"client"} />
          )
        ) : (
          <InfiniteScrollBox
            data={documentListNewCard.current}
            height={"397px"}
            width="100%"
            endReached={() =>
              docList &&
              docList?.length < documentState.docListInfo.total &&
              changeDocFilters({ ...docFilter, page: docFilter.page + 1 })
            }
          />
        )
      ) : (
        <MeetingBottom
          meetingList={meetingList}
          isInitFilter={dateFilter === "1month"}
          tableHeight="384px"
          page="client_fav"
          handleInitFilter={() => changeFilterByKey("date", "1month")}
        />
      )}
      {settingButtonInfo.syncId && (
        <DropdownBody
          align="right"
          // width={"120px"}
          dropdownRef={inputRef}
          location={{ x: settingButtonInfo.x, y: settingButtonInfo.y }}
        >
          {utilsCommon.checkMenuAvailble(
            "unAuthDownload",
            settingButtonInfo.docInfo,
            "client"
          ) ? (
            <DropdownItem
              label={t("file.action.download")}
              frontIcon={<Icons variant="line" label="download" />}
              onClick={() =>
                settingButtonInfo.docInfo &&
                doUnauthDocDownload(
                  settingButtonInfo.docInfo,
                  toasts,
                  getDocDecryptDownload,
                  startDownload
                )
              }
            />
          ) : (
            <>
              <DropdownItem
                label={t("file.action.download")}
                frontIcon={<Icons variant="line" label="download" />}
                onClick={() =>
                  handleDocClientDownload(settingButtonInfo.syncId)
                }
              />
              <DropdownItem
                label={t("file.detail")}
                frontIcon={<Icons variant="line" label="info" />}
                onClick={() =>
                  handleOpenClientDocInfo(settingButtonInfo.syncId)
                }
              />
            </>
          )}
        </DropdownBody>
      )}
    </Box>
  );
};

export default ClientBookmark;
